// 工事編集 工事情報画面
import {
  Button,
  Snackbar,
  TextField,
  Theme,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  ChangeEvent
} from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import LoadingComponent from '../components/LoadingComponent';
import { isLoggedIn, userSiteManagePlanId } from '../GlobalState';
import './List.css';
import { TypeTotallingTab } from '../components/attendanceManagementDashboard/TypeTotallingTab';
import { useSnackbar } from 'notistack';
import { getTotalingData } from '../apicalls/attendanceManages';
import { checkResData } from '../utils/common';
import { AttendanceManage } from './AttendanceManage';
import { TSelectItem } from '../types/common';
import { GANTT_SEARCH_HTML_ID, validationMessage } from '../const/ProcessConst';
import { FormProvider } from 'react-hook-form';
import { SiteProcessDatePicker } from '../components/parts/input/ProcessDatePicker';
import { validateGanttPeriod } from '../utils';
import { DatePickerInput } from '../components/atoms';
import { TGanttVisibleRange } from '../types/process';

const constructListDefaultVal = {
  value: 0,
  label: '--'
};

export const AttendanceManagementDashboard: React.FC = () => {
  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const classes = useStyles();
  const history: any = useHistory();
  const matches2 = useMediaQuery('(min-width:900px)');
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [constructListVal, setConstructListVal] = useState<TSelectItem>(
    constructListDefaultVal
  );
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>();
  const [endDate, setEndDate] = useState<Date | null>();
  const [initialVisibleRange, setInitialVisibleRange] =
    useState<TGanttVisibleRange>({
      start: '', // 表示期間が入ったときにガントチャートを表示するのでここは空文字にする
      end: ''
    });

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  // 選択タブ番号(1:工事情報、2:書類情報、3:現場情報、4:追加情報)
  const [selectTab, setSelectTab] = useState<number>(0);

  const handleChangeStartDatePicker = (
    date: Date | null,
    value?: string | null | undefined
  ) => {
    setStartDate(date);
    setInitialVisibleRange({
      start: date
        ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
            2,
            '0'
          )}-${String(date.getDate()).padStart(2, '0')}`
        : '',
      end: initialVisibleRange.end
    });
  };

  // 検索の終了日が変更になったときのイベントハンドラ
  const handleChangeEndDatePicker = (
    date: Date | null,
    value?: string | null | undefined
  ) => {
    if (date) {
      const modifiedDate = new Date(date);
      modifiedDate.setDate(modifiedDate.getDate() + 1); // 日付を+1
      setEndDate(date);
      setInitialVisibleRange({
        start: initialVisibleRange.start,
        end: modifiedDate.toISOString().split('T')[0]
      });
    } else {
      setEndDate(null);
      setInitialVisibleRange({
        start: initialVisibleRange.start,
        end: ''
      });
    }
  };

  useEffect(() => {
    const today = new Date();
    const oneMonthLater = new Date(today);
    oneMonthLater.setMonth(today.getMonth() + 1);
    // 初期表示のガントチャートの末日を設定
    const adjustedEndDate = new Date(oneMonthLater);
    adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);
    const rangeDate = {
      start: `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
        2,
        '0'
      )}-${String(today.getDate()).padStart(2, '0')}`,
      end: `${adjustedEndDate.getFullYear()}-${String(
        adjustedEndDate.getMonth() + 1
      ).padStart(2, '0')}-${String(adjustedEndDate.getDate()).padStart(2, '0')}`
    };

    setStartDate(today);
    setEndDate(oneMonthLater);
    setInitialVisibleRange(rangeDate);
  }, []);

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent patternName='attendance' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>
              <div className='table-top-container-customer'>
                <div style={{ fontWeight: 'bold' }}>
                  <Button
                    style={{
                      minWidth: 90,
                      marginRight: 15,
                      color: '#758283',
                      backgroundColor: '#F5F5F5',
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      // アラートメールからアクセスした場合は、工事一覧へ戻る
                      if (history.location.state) {
                        if (history.location.state.params) {
                          history.push(
                            '/constructions',
                            history.location.state
                          );
                        } else if (history.location.state?.currentPage) {
                          history.push(
                            '/constructions',
                            history.location.state
                          );
                        } else {
                          history.goBack();
                        }
                      } else {
                        history.push('/constructions');
                      }
                    }}
                    startIcon={<ArrowBackIcon />}
                  >
                    戻る
                  </Button>
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: '#FFF', padding: '25px 0' }}>
              <div id={GANTT_SEARCH_HTML_ID}>
                <div className={classes.searchPeriodWrapper}>
                  {startDate && endDate && (
                    <>
                      <div
                        style={{
                          marginLeft: 10,
                          marginRight: 15,
                          backgroundColor: '#FFFFFF',
                          height: 42,
                          paddingBottom: 5,
                          paddingLeft: 5
                        }}
                        className={'select-div-div'}
                      >
                        <DatePickerInput
                          date={startDate}
                          onChange={handleChangeStartDatePicker}
                          id={'submission_date'}
                          emptyLabel={'日付を選択'}
                        />
                      </div>
                      <div className={classes.waveDash}>
                        <Typography>～</Typography>
                      </div>
                      <div
                        style={{
                          marginLeft: 10,
                          marginRight: 15,
                          backgroundColor: '#FFFFFF',
                          height: 42,
                          paddingBottom: 5,
                          paddingLeft: 5
                        }}
                        className={'select-div-div'}
                      >
                        <DatePickerInput
                          date={endDate}
                          onChange={handleChangeEndDatePicker}
                          id={'submission_date'}
                          emptyLabel={'日付を選択'}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: '#FFFFFF' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: matches2 ? 'row' : 'column'
                }}
                className={classes.topList}
              >
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ width: 15 }}
                ></div>
                <div
                  onClick={() => setSelectTab(0)}
                  className='border2'
                  style={{
                    backgroundColor: selectTab == 0 ? '#F5F5F5' : '#ffffff',
                    borderTopColor: selectTab == 0 ? '#0099CB' : '#cccccc',
                    borderBottom: selectTab == 0 ? 'none' : 'solid 1px #cccccc',
                    width: 200
                  }}
                >
                  <div
                    className={classes.topColumn}
                    style={{ color: selectTab == 0 ? '#0099CB' : '#000000' }}
                  >
                    工程別
                  </div>
                </div>
                <div
                  onClick={() => setSelectTab(1)}
                  className='border2'
                  style={{
                    backgroundColor: selectTab == 1 ? '#F5F5F5' : '#ffffff',
                    borderTopColor: selectTab == 1 ? '#0099CB' : '#cccccc',
                    borderBottom: selectTab == 1 ? 'none' : 'solid 1px #cccccc',
                    width: 200
                  }}
                >
                  <div
                    className={classes.topColumn}
                    style={{ color: selectTab == 1 ? '#0099CB' : '#000000' }}
                  >
                    案件別
                  </div>
                </div>
                <div
                  onClick={() => setSelectTab(2)}
                  className='border2'
                  style={{
                    backgroundColor: selectTab == 2 ? '#F5F5F5' : '#ffffff',
                    borderTopColor: selectTab == 2 ? '#0099CB' : '#cccccc',
                    borderBottom: selectTab == 2 ? 'none' : 'solid 1px #cccccc',
                    width: 200
                  }}
                >
                  <div
                    className={classes.topColumn}
                    style={{ color: selectTab == 2 ? '#0099CB' : '#000000' }}
                  >
                    担当者別
                  </div>
                </div>
                <div
                  onClick={() => setSelectTab(3)}
                  className='border2'
                  style={{
                    backgroundColor: selectTab == 3 ? '#F5F5F5' : '#ffffff',
                    borderTopColor: selectTab == 3 ? '#0099CB' : '#cccccc',
                    borderBottom: selectTab == 3 ? 'none' : 'solid 1px #cccccc',
                    width: 200
                  }}
                >
                  <div
                    className={classes.topColumn}
                    style={{ color: selectTab == 3 ? '#0099CB' : '#000000' }}
                  >
                    協力業者別
                  </div>
                </div>
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
            </div>

            {selectTab == 0 && (
              <>
                <AttendanceManage
                  setConstructListVal={setConstructListVal}
                  constructListVal={constructListVal}
                  selectTab={selectTab}
                  initialVisibleRange={initialVisibleRange}
                />
              </>
            )}
            {selectTab == 1 && (
              <>
                <TypeTotallingTab
                  type={selectTab}
                  initialVisibleRange={initialVisibleRange}
                />
              </>
            )}
            {selectTab == 2 && (
              <>
                <TypeTotallingTab
                  type={selectTab}
                  initialVisibleRange={initialVisibleRange}
                />
              </>
            )}
            {selectTab == 3 && (
              <>
                <TypeTotallingTab
                  type={selectTab}
                  initialVisibleRange={initialVisibleRange}
                />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    topList: {
      display: 'flex',
      marginBottom: 25,
      width: '100%',
      justifyContent: 'flex-start'
    },
    topColumn: {
      fontSize: 16,
      color: '#000000'
    },
    searchPeriodWrapper: {
      display: 'flex',
      marginRight: '16px',
      verticalAlign: 'top',
      overflow: 'visible',
      whiteSpace: 'nowrap'
    },
    dateInput: {
      width: '145px'
    },
    waveDash: {
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      paddingRight: '8px',
      paddingLeft: '8px'
    }
  })
);
